// React
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Redux
import { useDispatch } from "react-redux";
import { openSnackbar } from "Store/SnackbarSlice";

// Material UI
import { Typography, Toolbar, AppBar } from "@mui/material";

// styles
import { styles } from "./styles";

// Resources
import { signOut } from "aws-amplify/auth";
import { LanguageSelector } from "Components/Language/languageSelector";
import { AvatarMenu } from "Common/Components";
import { clearAppSessionStorage } from "Auth/authUtils";

const NavigationBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElLanguage, setAnchorElLanguage] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleTitleClick = () => {
    navigate("/");
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      clearAppSessionStorage();
      window.location.reload();
    } catch (error) {
      dispatch(openSnackbar({ message: error.message, severity: "error" }));
    }
  };

  const handleMenuClick = (event) => {
    anchorEl !== event.currentTarget && setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const handleChangePasswordNavigate = () => {
  //   navigate("/ChangePassword");
  //   handleMenuClose();
  // };

  const handleOpenLanguage = (event) => {
    setAnchorElLanguage(event.currentTarget);
  };

  const handleCloseLanguage = () => {
    setAnchorElLanguage(null);
    handleMenuClose();
  };

  return (
    <AppBar position="sticky" sx={styles.navBar}>
      <Toolbar>
        <Typography onClick={handleTitleClick} sx={styles.title}>
          Medical Navigator
        </Typography>
        <AvatarMenu
          anchorEl={anchorEl}
          handleMenuClick={handleMenuClick}
          handleMenuClose={handleMenuClose}
          handleOpenLanguage={handleOpenLanguage}
          handleSignOut={handleSignOut}
        />
      </Toolbar>
      <LanguageSelector
        anchorEl={anchorElLanguage}
        open={Boolean(anchorElLanguage)}
        onClose={handleCloseLanguage}
        position="left"
      />
    </AppBar>
  );
};

export default NavigationBar;
